module.exports = __webpack_public_path__ + "static/media/carousel01.0d48ee7c.jpg";